import React from 'react';
import BrandPage from './BrandPage';

const EcactusPage = () => <BrandPage brandSlug="ecactus" />;

export default EcactusPage;
